/* eslint-disable camelcase */
import axios from 'axios'
import { wmSign, wmAes } from '../../apiFunction/encrypt'
import { GetTimeStamp } from '../../apiFunction/getDate'

const appURL = `${process.env.REACT_APP_APP_URL}/api`
const appId = process.env.REACT_APP_ID
const deviceUuid = process.env.REACT_APP_DEVICE_UUID

const header = {
  'Content-Type': 'application/json',
  'Accept-Language': 'zh-TW',
  'app-id': appId,
  'device-uuid': deviceUuid
}

async function ForgetPassword (datatest) {
  const body = {
    request_parameter: {
      mobile: wmAes(datatest.Member_mobile_number)
    },
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body)
  const data = {
    sign: sign
  }
  const response = await axios.post(
    `${appURL}/member/v1.2/forget_password`,
    data,
    { headers: header }
  )
  return response.data
}
async function ForgetPasswordVerify (datatest) {
  const body = {
    temp_access_token: datatest.tempAccessToken,
    request_parameter: {
      verify_code: datatest.formValue
    },
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${appURL}/member/forget_password_verify`, data, { headers: header })
  return response.data
}
async function ResendForgetPasswordVerify (datatest) {
  const body = {
    temp_access_token: datatest.tempAccessToken,
    request_parameter: {},
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${appURL}/member/resend_forget_verify`, data, { headers: header })
  return response.data
}

export { ForgetPassword, ForgetPasswordVerify, ResendForgetPasswordVerify }
